import React from 'react'
import DataTable from '../../../../components/DataTable'
import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import Container from '../../../../components/Container'

const ClientApplicationUserList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={[]}>
    <DataTable
      source={nameSource}
      entity={nameEntity}
      format={{ orderBy: '' }}
      notHasChildren
      headers={headers}
    />
  </Container>
)

export default ClientApplicationUserList
